// @ts-nocheck

import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Lottie from 'lottie-react';

import bubbleLoaderAnimation from '../../static/bubble-loader.json';
import waveLoaderAnimation from '../../static/wave-loader.json';

import ModelUploadWithSearch from '../../components/ModelUploadWithSearch';
import ToastMessageDialogue from '../../components/common/ToastMessageDialogue';
import IconButton from '../../components/common/Buttons/IconButton';
import SideBarAnimation from '../../components/common/SideBarAnimation';
import SearchResultsList from '../Ops/SearchResults';

import { useInterval } from '../../hooks/useInterval';

import { useCommonStore } from '../../stores/commonStore';
import { useAuthStore } from '../../stores/authStore';

import { searchProductForHotSpots } from '../../utils/api/hotspotApis';
import { getRequestStatus, triggerDownStreamPipelineRequest, uploadModel } from '../../utils/api/requestApi';
import { generateDownstreamPipelinePayload } from '../../utils/payloadUtil';

import { LeftArrow } from '../../icons/LeftArrow';

import { PipelineResponse } from '../../types/pipeline';

import { ROLES_MAPPING } from '../../utils/constants';
import { Routes } from '../../utils/constants/routes';
import { validateGlb } from '../../utils/fileUtils';

const HotspotSearchResult = ({ hotSpots, resetSearch }) => {
    return (
        <div className="flex flex-col w-full h-full mt-20">
            <div className="flex items-center w-full justify-between rounded-md p-4">
                <h2 className="text-2xl ">Search Results</h2>
                <button type="button" className="text-white text-lg rounded-lg px-4 py-2 bg-blue-700 ml-4" onClick={resetSearch}>
                    Reset Search
                </button>
            </div>
            <SearchResultsList hotSpots={hotSpots} />
        </div>
    );
};

const Trigger3DModelByGLB = () => {
    const history = useHistory();

    const [hotSpots, setHotSpots] = useState<any>([]);
    const [files, setFiles] = useState<any | null>(null);
    const [isPendingRequest, setIsPendingRequest] = useState<boolean>(false);
    const [showUploadDialog, setShowUploadDialog] = useState<boolean>(true);
    const [searchFsn, setSearchFsn] = useState('');

    const [requestQueue, setRequestQueue] = useState<any>([]);
    const [uploadApiRes, setUploadApiRes] = useState<any>([]);
    const [uniqueFSNs, setUniqueFSNs] = useState<any>(new Set());

    const sideBarOpen: boolean = useCommonStore((state) => state.sideBarOpen);
    const isUploadInitiated = useCommonStore((state) => state.isUploadInitiated);
    const currentRequestId = useCommonStore((state) => state.currentRequestId);
    const setCurrentRequestId = useCommonStore((state) => state.setCurrentRequestId);
    const setIsUploadInitiated = useCommonStore((state) => state.setIsUploadInitiated);
    const setToastMessage = useCommonStore((state) => state.setToastMessage);
    const setModelUploadApiResponse = useCommonStore((state) => state.setModelUploadApiResponse);
    const setThreeDLiveFsns = useCommonStore((state) => state.setThreeDLiveFsns);
    const setLoading = useCommonStore((state) => state.setLoading);

    const activeRole = useAuthStore((state) => state.activeRole);
    const activePartner = useAuthStore((state) => state.activePartner);

    const [modelUploadApiResponseLength, setModelUploadApiResponseLength] = useState(0);

    function checkBatchStatus(id) {
        return new Promise((resolve, reject) => {
            // Define a function that will be called recursively to poll the status
            const getModelPipelineResponse = async () => {
                try {
                    const requestParams = {
                        requestId: id
                    };

                    // console.log('triggerin ' + id);
                    const response = await getRequestStatus<any>(requestParams);

                    // setModelUploadApiResponseLength(response.data.length);

                    if (response.data.length !== 0) {
                        const allFinal = response.data.every((item) => item.status === 'COMPLETED' || item.status === 'FAILED');
                        if (allFinal) {
                            // console.log('complekted' + id);
                            // console.log(response);
                            resolve(response.data);
                        } else {
                            // console.log(`Batch ${id} still in progress`);
                            // If not completed, set a timeout to try again
                            setTimeout(getModelPipelineResponse, 1000); // Retry after 1 seconds
                        }

                        // setUploadApiRes([...response.data, ...uploadApiRes]); // aggregate uploads for pipeline trigge
                    } else {
                        // console.log(`Batch ${id} still in progress`);
                        // If not completed, set a timeout to try again
                        setTimeout(getModelPipelineResponse, 1000); // Retry after 1 seconds
                    }
                } catch (error) {
                    console.error(`Error checking status for batch ${id}:`, error);
                    reject(error); // Reject the promise if there's an error
                }
            };

            getModelPipelineResponse(); // Start polling
        });
    }

    // const getModelPipelineResponse = async (id) => {
    //     try {
    //         const requestParams = {
    //             requestId: id
    //         };

    //         console.log("triggerin " + id);
    //         const response = await getRequestStatus<any>(requestParams);

    //         // setModelUploadApiResponseLength(response.data.length);

    //         if (response.data.length !== 0) {

    //             setUploadApiRes([...response.data, ...uploadApiRes]); // aggregate uploads for pipeline trigger

    //             let fsns: any = new Set(uniqueFSNS);
    //             response?.data.forEach((item: PipelineResponse) => {
    //                 if (item.status === 'COMPLETED') {
    //                     fsns.add(item.uniqueId);
    //                     uniqueFSNS = fsns;
    //                 }
    //             });
    //             console.log('completed' + id)
    //         } else {
    //             console.log(`Batch ${id} still in progress`);
    //             // Schedule a retry after some delay
    //             setTimeout(() => getModelPipelineResponse(id), 1000); // Retry after 10 seconds
    //         }

    //         // console.log(activeRequests, 'check all active ones');
    //         // const nextRequest = requestQueue.pop();

    //         // if(nextRequest) {
    //         //     setUploadRequest(nextRequest);
    //         //     setIsPendingRequest(true);

    //         // }
    //         // else {
    //         //     setIsPendingRequest(false);
    //         //     setShowUploadDialog(false);
    //         //     console.log(uniqueFSNs, uploadApiRes);
    //         //     setModelUploadApiResponse([...uploadApiRes]);
    //         //     const triggerPipelinePayload: any = uniqueFSNs;
    //         //     handleTriggerDownstreamPipeline(triggerPipelinePayload);
    //         // }
    //     } catch (e) {
    //         setToastMessage({ type: 'error', message: 'Something went wrong while getting the request status' });
    //         // setIsPendingRequest(false);
    //         console.log('error while getting the request status', e);
    //     }
    // };

    // useEffect(() => {
    //     getModelPipelineResponse();
    // }, [currentRequestId])

    const handleTriggerDownstreamPipeline = async (fsnIds: string[]) => {
        try {
            const payload = generateDownstreamPipelinePayload(fsnIds);

            // console.log('trigger pipeline ' + fsnIds);

            const response = await triggerDownStreamPipelineRequest(payload);
            // console.log(response);
            setCurrentRequestId(response.data.requestId);
            // setToastMessage({ type: 'success', message: 'Success', description: 'Pipeline processed assets successfully' });
            setIsUploadInitiated(false);
            history.push(Routes.PREVIEW);
            // setIsPendingRequest(true);
        } catch (e) {
            // setIsPendingRequest(false);
            setToastMessage({ type: 'error', message: 'Pipeline Failed', description: 'Something went wrong while processing assets' });
            console.log('error while triggering the 3D Model Pipeline', e);
        }
    };

    // useInterval(getModelPipelineResponse, isPendingRequest ?  DELAY : null);

    const resetData = () => {
        setModelUploadApiResponse([]);
        setThreeDLiveFsns([]);
    };

    function splitFilesIntoBatches(filesInput) {
        const batchSize = 20; // Maximum number of files per batch
        const batches: any[][] = [];

        const files = Array.from(filesInput);

        for (let i = 0; i < files.length; i += batchSize) {
            const batch = files.slice(i, i + batchSize);
            batches.push(batch);
        }

        return batches;
    }

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        // setLoading(true);

        const files = event.target.files;

        if (files?.length && activePartner === 'flipkart') {
            // only validate for FK
            const validation: { valid: boolean; error?: string } = validateGlb(files);

            if (!validation.valid && validation.error) {
                return setToastMessage({ type: 'error', message: validation.error }, 2000);
            }
        }

        resetData();
        setIsUploadInitiated(true);

        if (files && files.length > 0 && files[0] !== null) {
            const fileBatches = splitFilesIntoBatches(files);
            const requestQueue: Array<any> = [];
            // console.log(fileBatches);
            // setBatchLength(fileBatches.length);

            if (fileBatches.length > 0 && fileBatches[0] !== null) {
                setFiles(fileBatches[0]);
                try {
                    //upload first batch
                    // console.log('uploading 0');
                    const response = await uploadModel(fileBatches[0]);
                    // console.log(fileBatches[0], 'resgistered 0');
                    requestQueue.push(response.data.requestId);
                    setCurrentRequestId(response.data.requestId);
                    // setShowUploadDialog(false);
                    // setToastMessage({ type: 'success', message: 'Batch Upload Successfully...' });
                    setIsPendingRequest(true);
                    // getModelPipelineResponse(response.data.requestId);
                } catch (error) {
                    setToastMessage({ type: 'error', message: 'Upload Failure', description: 'Something went wrong while uploading file' });
                    console.log('error:', error);
                } finally {
                    // setIsUploadInitiated(false);
                }

                //upload remaining batches
                if (fileBatches.length > 1) {
                    for (let i = 1; i < fileBatches.length; i++) {
                        try {
                            // console.log('uploading' + i);
                            const response = await uploadModel(fileBatches[i]);
                            // console.log(fileBatches[i], 'registering');
                            requestQueue.push(response.data.requestId);
                            // getModelPipelineResponse(response.data.requestId);
                            // setToastMessage({ type: 'success', message: 'Batch ' + i + ' Upload Successfully...' });
                        } catch (error) {
                            setToastMessage({ type: 'error', message: 'Upload Failure', description: 'Something went wrong while uploading file' });
                            console.log('error:', error);
                        }
                    }
                }

                // console.log(requestQueue);
                const statusChecks = requestQueue.map((batchId) => checkBatchStatus(batchId));
                const batchResults = await Promise.all(statusChecks);
                // console.log('all done');
                const aggregatedData = batchResults.reduce((acc, batchData) => {
                    // Assuming batchData is an array, concatenate it with the accumulator
                    // Adjust this logic based on the actual structure of your batch response data
                    return acc.concat(batchData);
                }, []);

                let uniqueFSNs: any = new Set();
                aggregatedData.forEach((item: PipelineResponse) => {
                    if (item.status === 'COMPLETED') {
                        uniqueFSNs.add(item.uniqueId);
                    }
                });

                // console.log(uniqueFSNs, aggregatedData);
                setModelUploadApiResponse([...aggregatedData]);
                setToastMessage({ type: 'success', message: 'Success', description: 'File uploaded successfully' });
                const triggerPipelinePayload: any = uniqueFSNs;
                handleTriggerDownstreamPipeline(triggerPipelinePayload);
            }
        }
    };

    const handleLogout = () => {
        localStorage.clear();
        // window.location.reload();
        history.push(Routes.LOGIN);
        // clearAndHandleLogout();
    };

    const handleGoBack = () => {
        history.push(Routes.OPS_ROUTES.ROOT);
    };

    const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchFsn(event.target.value);
    };

    const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        await handleSearchRequest();
    };

    const handleSearchRequest = async () => {
        try {
            setLoading(true);
            const { data } = await searchProductForHotSpots(searchFsn);

            if (data.length === 0) {
                setHotSpots([]);
                setToastMessage({ type: 'error', message: 'Incorrect FSN' });
            } else {
                const formattedData = [data];
                setHotSpots(formattedData);
                setShowUploadDialog(false);
            }
        } catch (e) {
            setToastMessage({ type: 'error', message: 'Something went wrong in searching hotspots' });
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handleFileUploadClick = () => {
        const fileInput = document.getElementById('fileInput');
        fileInput?.click();
    };

    const resetSearch = () => {
        setShowUploadDialog(true);
        setHotSpots([]);
    };

    const modalPipelinePercentage = Math.floor((modelUploadApiResponseLength / (files?.length || 100)) * 100);
    // setToastMessage({ type: 'info', message: 'Success', description: 'File uploaded successfully' }, 1000000);

    return (
        <main className="flex container-height ">
            <ToastMessageDialogue />
            <SideBarAnimation open={sideBarOpen} type={ROLES_MAPPING[activeRole]} onClick={handleLogout} />

            <div className="flex items-center justify-center w-full">
                <div className="absolute left-40 top-28">
                    {/* <IconButton label="Go Back" onClick={handleGoBack} color="" borderColor="white" textColor="gray">
                    <LeftArrow />
                </IconButton>  */}
                    <h2 style={{ color: 'black', fontSize: 24, fontWeight: 500 }}>Upload GLB file</h2>
                    <p style={{ color: '#717478', fontWeight: 300, fontSize: '16px', margin: 0, padding: 0 }}>Use a CSV of Products to create a new request for 3D models, Ensure it follows the guidelines. </p>
                </div>

                <div className="text-center  custom-border flex items-center justify-center rounded-lg">
                    {isUploadInitiated ? (
                        <div className="w-full h-auto flex flex-col justify-center items-center">
                            <div className="flex justify-center items-center  h-auto" style={{ width: 220 }}>
                                <Lottie animationData={waveLoaderAnimation} loop={true} autoPlay={true} />
                            </div>
                            <h1 style={{ color: '#2A55E5', fontSize: 16, fontWeight: 700, marginTop: '-46px' }}> Upload In Progress</h1>
                            <h1 style={{ color: '#717478', fontSize: 16, fontWeight: 500 }}>Please Keep this Tab Open</h1>
                        </div>
                    ) : (
                        <div className="w-full h-full p-8 flex items-center justify-center flex-col relative">
                            {showUploadDialog ? (
                                <ModelUploadWithSearch onFileChange={handleFileChange} onFileUploadClick={handleFileUploadClick} onFormSubmit={handleFormSubmit} onSearchInputChange={handleSearchInputChange} />
                            ) : hotSpots.length ? (
                                <HotspotSearchResult hotSpots={hotSpots} resetSearch={resetSearch} />
                            ) : (
                                <>
                                    <div className="flex justify-center items-center w-1/2 h-auto">
                                        <Lottie animationData={waveLoaderAnimation} loop={true} autoPlay={true} />
                                    </div>
                                    <h1 className="text-blue-700">Running Upload(Orchaestrator) Pipeline ({modalPipelinePercentage}%)</h1>
                                    <h1>Please Keep this Tab Open</h1>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </main>
    );
};

export default Trigger3DModelByGLB;
